import React from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import AboutMe from '../AboutMe';
import Articles from '../Articles';
import Resume from '../Resume';
import Projects from '../Projects';

function Home() {
  return (
    <>
      <div className="main_container" style={{scrollSnapType: 'y mandatory'}}>
        <HeroSection />
        <AboutMe />
        <Resume />
        <Articles />
        <Projects />
      </div>
    </>
  );
}

export default Home;